import { supabase } from "@/integrations/supabase/client";

export const CHURN_REASONS = [
  { value: "too_expensive", label: "Too expensive" },
  { value: "not_using", label: "Not using it enough" },
  { value: "missing_features", label: "Missing features I need" },
  { value: "quality", label: "Answer quality wasn't good enough" },
  { value: "technical_issues", label: "Technical issues or bugs" },
  { value: "switching", label: "Switching to another app" },
  { value: "temporary", label: "Just a break — I'll be back" },
  { value: "other", label: "Something else" },
] as const;

export type ChurnReason = (typeof CHURN_REASONS)[number]["value"];

export async function recordChurnReason(params: {
  userId: string;
  reason: ChurnReason | string;
  details?: string;
  priceId?: string | null;
}) {
  const { error } = await supabase.from("churn_reasons").insert({
    user_id: params.userId,
    reason: params.reason,
    details: params.details?.trim() || null,
    price_id: params.priceId ?? null,
  });
  if (error) throw new Error(error.message);
}
